// @flow

import * as React from 'react';
import { graphql, useFragment } from 'react-relay';
import { Flex, Box, useSystem } from 'react-system';
import { useLocale } from '../../controls/locale';
import { useTheme } from '../../theme';

import { DevelopmentOrganisation } from './DevelopmentOrganisation';

import type { DevelopmentProjectConsortium_development$key } from './__generated__/DevelopmentProjectConsortium_development.graphql';

type Props = {|
  development: DevelopmentProjectConsortium_development$key,
|};

export const DevelopmentProjectConsortium = (props: Props): React.Node => {
  const { text } = useTheme();
  const { media } = useSystem();
  const { t } = useLocale();
  const development = useFragment(
    graphql`
      fragment DevelopmentProjectConsortium_development on DevelopmentProduct {
        broker {
          organisation {
            ...DevelopmentOrganisation_organisation
          }
        }
        developer {
          ...DevelopmentOrganisation_organisation
        }
        architect {
          ...DevelopmentOrganisation_organisation
        }
        generalContractor {
          ...DevelopmentOrganisation_organisation
        }
      }
    `,
    props.development,
  );
  const consortium = [
    {
      label: t('developer'),
      organisation: development.developer,
    },
    {
      label: t('broker'),
      organisation: development.broker?.organisation,
    },
    {
      label: t('architect'),
      organisation: development.architect,
    },
    {
      label: t('generalContractor'),
      organisation: development.generalContractor,
    },
  ];

  return (
    <>
      {consortium.length > 0 && (
        <Box py={3} css={media([text.h6, text.h5])}>
          {t('projectConsortium')}
        </Box>
      )}
      <Flex flexWrap="wrap" mx={-2}>
        {consortium.map(
          ({ label, organisation }, i) =>
            organisation != null && (
              <Box key={i} p={2} width={[1, 1, 1 / 2]}>
                <DevelopmentOrganisation
                  key={i}
                  label={label}
                  organisation={organisation}
                />
              </Box>
            ),
        )}
      </Flex>
    </>
  );
};
